import { t } from "@/i18n-js/instance";

export const STYLES_COLORS = [
  {
    title: t(
      "builder_ui.css_variables.colors.styles.variables.background_primary",
    ),
    name: "theme-website-color-background-primary",
    variable: "theme-website-color-background-primary",
  },
  {
    title: t(
      "builder_ui.css_variables.colors.styles.variables.background_secondary",
    ),
    name: "theme-website-color-background-secondary",
    variable: "theme-website-color-background-secondary",
  },
  {
    title: t("builder_ui.css_variables.colors.styles.variables.border"),
    name: "theme-website-color-border",
    variable: "theme-website-color-border",
  },
  {
    title: t("builder_ui.css_variables.colors.styles.variables.text_primary"),
    name: "theme-website-color-text-primary",
    variable: "theme-website-color-text-primary",
  },
  {
    title: t("builder_ui.css_variables.colors.styles.variables.text_secondary"),
    name: "theme-website-color-text-secondary",
    variable: "theme-website-color-text-secondary",
  },
  {
    title: t("builder_ui.css_variables.colors.styles.variables.text_link"),
    name: "theme-website-color-text-link",
    variable: "theme-website-color-text-link",
  },
];
